import { useAppSelector } from '@/hooks/use.redux';
import { useCallback, useEffect, useState } from 'react';

export function useCallConnection() {
  const activeCall = useAppSelector((state) => state.callReducer.activeCall);
  const [callState, setCallState] = useState(activeCall?.connection.getState());

  const listener = useCallback(() => {
    setCallState(activeCall?.connection.getState());
  }, [activeCall?.connection]);

  useEffect(() => {
    activeCall?.connection.on('state-change', listener);
    return () => {
      activeCall?.connection.off('state-change', listener);
    };
  }, [activeCall?.connection, listener]);

  useEffect(() => {
    if (!activeCall) {
      setCallState(null);
    }
  }, [activeCall]);

  return {
    activeCall: activeCall?.connection,
    activeCallId: activeCall?.connection._id,
    callState,
    isPip: activeCall?.pip,
  };
}
